export const testimonials = [
  {
    id: '1',
    companyLogo: '/assets/website/logo-1.svg',
    companyName: 'Netcraft',
    quote:
      "OGISO WAS AN INCREDIBLE PARTNER IN THE PROCESS OF STREAMLINING OUR CARE MANAGEMENT. THEY'RE CLEARLY ONE OF THE BEST IN THE INDUSTRY AND FELT LIKE AN EXTENSION OF OUR TEAM.",
    authorName: 'Sarah Johnson',
    authorTitle: 'Director of Operations @ CareFirst',
  },
  {
    id: '2',
    companyLogo: '/assets/website/logo-2.svg',
    companyName: 'HealthPlus',
    quote:
      'THE EMAR SYSTEM HAS TRANSFORMED HOW WE HANDLE MEDICATION ADMINISTRATION. ERRORS ARE DOWN 90% AND OUR STAFF LOVES THE INTUITIVE INTERFACE.',
    authorName: 'Michael Chen',
    authorTitle: 'CEO @ HealthPlus Care',
  },
  {
    id: '3',
    companyLogo: '/assets/website/logo-3.svg',
    companyName: 'CareConnect',
    quote:
      'BILLING USED TO BE OUR BIGGEST HEADACHE. NOW WITH OGISO, WE GET PAID FASTER AND SPEND MORE TIME ON WHAT MATTERS - OUR PATIENTS.',
    authorName: 'Emily Rodriguez',
    authorTitle: 'Finance Manager @ CareConnect',
  },
];
